export const COMPANY_SIZE_OPTIONS = [
  { value: '1-10', label: '1 - 10' },
  { value: '11-50', label: '11 - 50' },
  { value: '51-200', label: '51 - 200' },
  { value: '201-500', label: '201 - 500' },
  { value: '500+', label: '500+' },
];

export const INDUSTRY_OPTIONS = [
  {
    value: 'Aerospace & Defense',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.AEROSPACE_DEFENSE',
  },
  {
    value: 'Agriculture & Food',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.AGRICULTURE_FOOD',
  },
  {
    value: 'Automotive & Transportation',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.AUTOMOTIVE_TRANSPORTATION',
  },
  {
    value: 'Chemicals & Materials',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.CHEMICALS_MATERIALS',
  },
  {
    value: 'Construction & Built Environment',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.CONSTRUCTION',
  },
  {
    value: 'Consumer Packaged Goods (CPG)',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.CONSUMER_GOODS',
  },
  {
    value: 'Education',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.EDUCATION',
  },
  {
    value: 'Entertainment',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.ENTERTAINMENT',
  },
  {
    value: 'Finance',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.FINANCE',
  },
  {
    value: 'Government & Nonprofit',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.GOVERNMENT_NONPROFIT',
  },
  {
    value: 'Healthcare',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.HEALTHCARE',
  },
  {
    value: 'Hospitality & Tourism',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.HOSPITALITY_TOURISM',
  },
  {
    value: 'Industrial & Energy',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.INDUSTRIAL_ENERGY',
  },
  {
    value: 'Legal & Compliance',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.LEGAL_COMPLIANCE',
  },
  {
    value: 'Lifestyle & Leisure',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.LIFESTYLE_LEISURE',
  },
  {
    value: 'Logistics & Supply Chain',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.LOGISTICS_SUPPLY_CHAIN',
  },
  {
    value: 'Luxury & Fashion',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.LUXURY_FASHION',
  },
  {
    value: 'News & Media',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.NEWS_MEDIA',
  },
  {
    value: 'Professional Services & Agencies',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.PROFESSIONAL_SERVICES',
  },
  {
    value: 'Real Estate & PropTech',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.REAL_ESTATE',
  },
  {
    value: 'Retail & E-commerce',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.RETAIL_ECOMMERCE',
  },
  {
    value: 'Sports',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.SPORTS',
  },
  {
    value: 'Technology',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.TECHNOLOGY',
  },
  {
    value: 'Telecommunications',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRY.TELECOMMUNICATIONS',
  },
  {
    value: 'Other',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.COMMON.OTHER',
  },
];

export const REFERRAL_SOURCE_OPTIONS = [
  { value: 'google', label: 'Google' },
  { value: 'reddit', label: 'Reddit' },
  { value: 'twitter', label: 'Twitter/X' },
  { value: 'linkedin', label: 'LinkedIn' },
  {
    value: 'friend',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.REFERRAL.FRIEND_COLLEAGUE',
  },
  {
    value: 'blog',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.REFERRAL.BLOG_ARTICLE',
  },
  { value: 'github', label: 'GitHub' },
  { value: 'other', labelKey: 'ONBOARDING_NEXT.OPTIONS.COMMON.OTHER' },
];

export const USER_ROLE_OPTIONS = [
  {
    value: 'founder',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.USER_ROLE.FOUNDER',
  },
  {
    value: 'product_manager',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.USER_ROLE.PRODUCT_MANAGER',
  },
  {
    value: 'engineering',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.USER_ROLE.ENGINEERING',
  },
  {
    value: 'support_lead',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.USER_ROLE.SUPPORT_LEAD',
  },
  {
    value: 'marketing',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.USER_ROLE.MARKETING',
  },
  {
    value: 'sales',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.USER_ROLE.SALES',
  },
  { value: 'other', labelKey: 'ONBOARDING_NEXT.OPTIONS.COMMON.OTHER' },
];
